'use strict';

module.exports = function () {
    $('body')
        .off('rxb2c:openconfirmationmodal')
        .on('rxb2c:openconfirmationmodal', function (e, { actionTarget, productToAddIsRX }) {
            var $modal = $('#rxB2CAddToCartModal');
            var currentCartIsRX = $('input[name="currentCartIsRX"]', $modal).val() === 'true';
            var $targetedContentAsset = $('.js-content-asset-case[data-cart-is-plano="true"]', $modal);

            if (currentCartIsRX) {
                $targetedContentAsset = $(`.js-content-asset-case[data-cart-is-plano="false"][data-future-cart-is-plano="${!productToAddIsRX}"]`, $modal);
            }

            $('.js-content-asset-case', $modal).addClass('d-none');
            $targetedContentAsset.removeClass('d-none');
            $modal.modal('show');

            $($modal).off('click', '.js-confirm').on('click', '.js-confirm', function () {
                $('input[name="customerConfirmSubmit"]', $modal).val(true);
                actionTarget.first().click();
                $modal.modal('hide');
            });
        });
};
